import { Phone, WhatsApp } from "@mui/icons-material";
import { no_wa } from "../firebase_setup/firebase";
import { useEffect, useState } from "react";
import { DialogContentText,
        CardActionArea,
        DialogContent,
        DialogActions,
        DialogTitle,
        CardContent,
        Typography,
        Dialog,
        Button,
        Stack,
        Card,
        Box,
     } from "@mui/material";

const ContactForm = ({ open, onClose }) => {
    const [dialogOpen, setDialogOpen] = useState(false);

    const handleClose = () => {
        setDialogOpen(false);
        onClose();
    };

    useEffect(() => {
        setDialogOpen(open);
    }, [open]);

    return (
        <Dialog
            open={dialogOpen}
            onClose={() => handleClose()}
            maxWidth='md'
        >
            <DialogTitle>
                Contáctanos
            </DialogTitle>
            <DialogContent>
                <DialogContentText sx={{ marginBottom: "2rem" }}>
                    Para mayor información, ponemos a su disposición los siguientes medios de contacto:
                </DialogContentText>
                <Box
                    sx={{
                        width: {xs: '90%', md: '96%'},
                        margin: {xs: '5%', md: '2%'},
                        display: 'grid',
                        gridTemplateColumns: 'repeat(auto-fill, minmax(min(300px, 100%), 1fr))',
                        gap: 2
                    }}
                >
                    <Card key={'contact_wa'}>
                        <CardActionArea sx={{ height: '100%' }} href={`https://wa.me/52${no_wa}`} target="_blank">
                            <CardContent sx={{ height: '100%' }}>
                                <Stack direction="row" spacing={1} sx={{ display: 'flex', justifySelf: 'center' }}>
                                    <Typography variant="h4" component="div">
                                        <WhatsApp fontSize="inherit" color="success" />
                                    </Typography>
                                    <Typography variant="h5" component="div">
                                        (55) 4072 2582
                                    </Typography>
                                </Stack>
                            </CardContent>
                        </CardActionArea>
                    </Card>
                    <Card key={'contact_phone'}>
                        <CardActionArea sx={{ height: '100%' }} href="tel:+525593030398">
                            <CardContent sx={{ height: '100%' }}>
                                <Stack direction="row" spacing={1} sx={{ display: 'flex', justifySelf: 'center' }}>
                                    <Typography variant="h4" component="div">
                                        <Phone fontSize="inherit" color="success" />
                                    </Typography>
                                    <Typography variant="h5" component="div">
                                        (55) 9303 0398
                                    </Typography>
                                </Stack>
                            </CardContent>
                        </CardActionArea>
                    </Card>
                </Box>
            </DialogContent>
            <DialogActions>
                <Button onClick={() => handleClose()}>Aceptar</Button>
            </DialogActions>
        </Dialog>
    );
};

export default ContactForm;
